"use client";
import { createSlice } from "@reduxjs/toolkit";
import { getEnergyPackages, getPackagePurchaseHistory, getHotOfferPackage } from "./actions";

const initialState = {
    loadingEnergyPackages: false,
    energyPackageList: [],
    totalEnergyPackages: 0,
    loadingPurchaseHistory: false,
    packagePurchaseHistory: [],
    totalPackageHistory: 0,
    loadingOffer: false,
    offerPackage: {},
};

export const energySlice = createSlice({
    name: "energySlice",
    initialState,
    reducers: {
        clearEnergyPackageList(state, action) {
            state.energyPackageList = [];
            state.totalEnergyPackages = 0;
        },
        clearPackagePurchaseHistory(state, action) {
            state.packagePurchaseHistory = [];
            state.totalPackageHistory = 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEnergyPackages.pending, (state, action) => {
                state.loadingEnergyPackages = true;
            })
            .addCase(getEnergyPackages.fulfilled, (state, action) => {
                state.loadingEnergyPackages = false;
                state.energyPackageList =
                    action.payload?.filter?.page === 1
                        ? action.payload.data
                        : [...state.energyPackageList, ...action.payload.data];
                state.totalEnergyPackages = action.payload.totalcount;
            })
            .addCase(getEnergyPackages.rejected, (state, action) => {
                state.loadingEnergyPackages = false;
            })

            .addCase(getPackagePurchaseHistory.pending, (state, action) => {
                state.loadingPurchaseHistory = true;
            })
            .addCase(getPackagePurchaseHistory.fulfilled, (state, action) => {
                state.loadingPurchaseHistory = false;
                state.packagePurchaseHistory =
                    action.payload?.filter?.page === 1
                        ? action.payload.data
                        : [...state.packagePurchaseHistory, ...action.payload.data];
                state.totalPackageHistory = action.payload.totalcount;
            })
            .addCase(getPackagePurchaseHistory.rejected, (state, action) => {
                state.loadingPurchaseHistory = false;
            })

            .addCase(getHotOfferPackage.pending, (state, action) => {
                state.loadingOffer = true;
            })
            .addCase(getHotOfferPackage.fulfilled, (state, action) => {
                state.loadingOffer = false;
                state.offerPackage = action.payload.data;
            })
            .addCase(getHotOfferPackage.rejected, (state, action) => {
                state.loadingOffer = false;
            })
    }
});

export default energySlice.reducer;